module.exports = __webpack_public_path__ + "img/Refresh_icon.556a0c0e.svg";